import React, {useState,useEffect,useRef} from 'react';
import Pagination from "react-js-pagination";
import Sort from './Sort';
import DatasetSnippet from '../../../datasets/components/DatasetSnippet';
import ClassSnippet from '../../../classes/components/ClassSnippet';

import './Results.css';

const Result = props => {  
    const [sortedItems, setSortedItems]= useState(props.items);
    const sortedItemsRef= useRef(sortedItems);
    const [sortType, setSortType] = useState('title');
    const [slicedItems, setSlicedItems]= useState(sortedItemsRef.current);
    const slicedItemsRef= useRef(slicedItems);
    const [activePage, setActivePage]= useState(1);
 
  //  sortedDatasetsRef.current=sortedDatasets;
  //  slicedDatasetsRef.current=slicedDatasets;
    useEffect(()=>{
       sortedItemsRef.current=props.items;
       setSortedItems(props.items);  
       setActivePage(1);
       sortArray(sortType)
       slicedItemsRef.current=sortedItemsRef.current.slice(0,19);   
       setSlicedItems(slicedItemsRef.current);
    },[props.items]);

    const sortArray = (type) => {
        const types = {
          title: 'title',
          dataset: 'dataset',
          classes: 'classes',
          entities: 'entities',
          recommendations: 'recommendations',
        };
        const sortProperty = types[type];
        let sorted;
        if (sortProperty==='title'){
        sorted=sortedItemsRef.current.sort(function(a, b){
            if(a.title < b.title) { return -1; }
            if(a.title > b.title) { return 1; }
            return 0;
        });
        } else if (sortProperty==='dataset'){
        sorted=sortedItemsRef.current.sort(function(a, b){
            if(a.dataset < b.dataset) { return -1; }
            if(a.dataset > b.dataset) { return 1; }
            return 0;
        });
        } else {
            sorted=sortedItemsRef.current.sort((a, b) => b[sortProperty] - a[sortProperty]);
        }
        setSortType(type);
        setSortedItems(sorted);
        handlePageChange(activePage);
        };
       
      const handlePageChange = pageNumber => {
        setActivePage(pageNumber);
        setSlicedItems(sortedItemsRef.current.slice(pageNumber*20-20,pageNumber*20));  
       };
     
     return (
        <div className="ResultsDiv">
            <h1 className="results-title">{props.items.length>0 ? props.items.length + " " + props.type : "No " + props.type + " found"} </h1>
            <ul className="results-list">
            <div className="resultHandlersDiv">
            {props.items.length>0 && <Sort value={sortType} onChange={(e)=>sortArray(e.target.value)} type={props.type}/>}
            {props.items.length>0 && <Pagination
                activePage={activePage}
                itemsCountPerPage={20}
                totalItemsCount={props.items.length}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                innerClass=" pagination customPagination"
                />}
            </div>

            {props.type==="datasets" && slicedItems.map(dataset => (
                 <DatasetSnippet
                    key={dataset.id}
                    id={dataset.id}
                    image={`${process.env.REACT_APP_BACKEND_URL}/static/thumbnails/datasets/${dataset.id}.jpg`}
                    title={dataset.title}
                    description={dataset.description}
                    active={dataset.active_now}
                    numOfClasses={dataset.classes}
                    numOfEntities={dataset.entities}
                    numOfRecommendations={dataset.recommendations}
                />
                ))}
                 {props.type==="classes" && slicedItems.map(cs => (
                 <ClassSnippet
                    key={cs.id}
                    id={cs.id}
                    image={`${process.env.REACT_APP_BACKEND_URL}/static/thumbnails/classes/${cs.id}.jpg`}
                    title={cs.title}
                    description={cs.description}
                    uri={cs.uri}
                    dataset={cs.dataset}
                    datasetid={cs.datasetid}
                    numOfEntities={cs.entities}
                    numOfRecommendations={cs.recommendations}
                />
                ))}         
           </ul>
        </div>
     );
}

export default Result;